import React, { useEffect } from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import Alerta from "../../../../../Utils/Alerta/Alerta";
import { GestionAlmacenApi } from "../api/GestionAlmacenApi";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { NotificationManager } from "react-notifications";
import { CONFIG_TEXTOS_ACOPIO } from "../../../config/textosAcopio";
import {
    CATEGORIAS_ACOPIO,
    ESTADOS_INV_ALMACEN,
} from "../../../../../../../utility/constants";
import { RecepcionesSobranteTable } from "../../../components/Almacenes/RecepcionesSobranteTable";

export const Recepciones = (props) => {
    const {
        almacenInventarioId,
        estadoAlmacenInventario,
        movimientosAlmacen = [],
        setMovimientosAlmacen,
        estaCerrado,
        categoriaAcopio,
    } = props;

    const [idRecepcion, setIdRecepcion] = React.useState(null);

    const {
        getMovimientoFromRecepcion,
        getMovimientosNoTrasladados,
        cargando,
    } = GestionAlmacenApi();

    const BuscarMovFromRecepcion = async () => {
        try {
            if (!idRecepcion) {
                Alerta.error("Debe ingresar un ID de recepción válido");
                return;
            }

            const params = {
                inventario_almacen_id: almacenInventarioId,
                ingreso_id: idRecepcion,
            };

            const movimientos = await getMovimientoFromRecepcion(params);

            // Si los movimientos ya están en la lista, mostrar mensaje
            const movimientosNuevos = movimientos.filter(
                (mov) => !movimientosAlmacen.some((m) => m.id === mov.id),
            );

            if (movimientosNuevos.length === 0) {
                NotificationManager.info(
                    "La recepción ya ha sido agregada",
                    "Información",
                    3000,
                );
                return;
            }

            setMovimientosAlmacen((prev) => [...prev, ...movimientos]);

            setIdRecepcion(null);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al buscar recepción.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EliminarRecepcion = async (movimientoId) => {
        setMovimientosAlmacen((prev) =>
            prev.filter((mov) => mov.id !== movimientoId),
        );
    };

    const PrecargarMovimientosNoEnviados = async () => {
        if (categoriaAcopio !== CATEGORIAS_ACOPIO.ACOPIO) return;

        if (estadoAlmacenInventario !== ESTADOS_INV_ALMACEN.PENDIENTE) return;

        try {
            const params = {
                inventario_almacen_id: almacenInventarioId,
            };

            const movimientos = await getMovimientosNoTrasladados(params);

            setMovimientosAlmacen(movimientos);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cargar recepciones no trasladadas.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        PrecargarMovimientosNoEnviados();
    }, [almacenInventarioId, estadoAlmacenInventario]);

    const textConfig = CONFIG_TEXTOS_ACOPIO[categoriaAcopio];

    return (
        <LoadMask loading={cargando} blur>
            <div className="d-flex justify-content-between flex-wrap align-items-end mb-3">
                <h4 className="mb-0">{textConfig.textoRecepcionesSobrante}</h4>
                {!estaCerrado && (
                    <div className="formulario-fields-row ml-auto mb-0">
                        <div className="formulario-field">
                            <label>ID Recepción</label>
                            <input
                                name="id_recepcion"
                                value={idRecepcion || ""}
                                onChange={(e) => setIdRecepcion(e.target.value)}
                                className="form-control"
                                placeholder="ID Recepción"
                            />
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary mt-4"
                            onClick={BuscarMovFromRecepcion}
                            disabled={!idRecepcion}
                        >
                            Agregar
                        </button>
                    </div>
                )}
            </div>

            <RecepcionesSobranteTable
                recepciones={movimientosAlmacen}
                onEliminar={!estaCerrado ? EliminarRecepcion : null}
            />
        </LoadMask>
    );
};
